// src/components/Footer.tsx
import { Link } from 'react-router-dom'
import styles from './Footer.module.css'

export default function Footer() {
  const year = new Date().getFullYear()
  return (
    <footer className={styles.footer} itemScope itemType="https://schema.org/LocalBusiness">
      <div className="container">
        <div className={styles.grid}>
          <div className={styles.brand}>
            <div className={`${styles.logoText} display-font gradient-text`}>FreshDispense</div>
            <p itemProp="description">
              Edmonton's premier vending machine placement company. Custom vending solutions
              for gyms, bars, offices and venues across YEG and Alberta.
            </p>
            <div className={styles.socials}>
              <a href="https://instagram.com/freshdispense" aria-label="Instagram" className={styles.social}>📸</a>
              <a href="https://facebook.com/freshdispense" aria-label="Facebook" className={styles.social}>👍</a>
              <a href="https://linkedin.com/company/freshdispense" aria-label="LinkedIn" className={styles.social}>💼</a>
            </div>
          </div>

          <div className={styles.col}>
            <h5 className={styles.colTitle}>Company</h5>
            <ul className={styles.colList}>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/services">Services</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>

          <div className={styles.col}>
            <h5 className={styles.colTitle}>Services</h5>
            <ul className={styles.colList}>
              <li><Link to="/services#gyms">Gym Vending Edmonton</Link></li>
              <li><Link to="/services#bars">Bar Vending Edmonton</Link></li>
              <li><Link to="/services#snacks">Snack Vending YEG</Link></li>
              <li><Link to="/services#custom">Custom Solutions</Link></li>
            </ul>
          </div>

          <div className={styles.col}>
            <h5 className={styles.colTitle}>Contact</h5>
            <ul className={styles.colList}>
              <li>
                <a href="mailto:hello@freshdispense.com" itemProp="email">
                  hello@freshdispense.com
                </a>
              </li>
              <li>
                <a href="tel:+17801234567" itemProp="telephone">
                  +1 (780) 123-4567
                </a>
              </li>
              <li>
                <span itemProp="addressLocality">Edmonton</span>,{' '}
                <span itemProp="addressRegion">Alberta</span> 🇨🇦
              </li>
            </ul>
          </div>
        </div>

        <div className={styles.bottom}>
          <p>© {year} FreshDispense.com — All rights reserved.</p>
          <p>Proudly serving <strong>Edmonton, Alberta</strong></p>
        </div>
      </div>
    </footer>
  )
}
